import React from 'react';
import classNames from 'classnames';
import { ColorsType, keysOf } from '@vds/core';
import icons from '../assets/icons';
import './Icon.scss';

export type IconName = keyof typeof icons;

// Non-empty tuple so consumers can feed it straight into z.enum(ICON_NAMES).
const [firstIconName, ...otherIconNames] = keysOf(icons);
export const ICON_NAMES = [firstIconName, ...otherIconNames] as const;
export const ICON_SIZES = ['small', 'medium-small', 'medium', 'large', 'xl', 'xxl'] as const;

export type IconSize = (typeof ICON_SIZES)[number];

export interface IconProps {
  label?: string;
  className?: string;
  name: IconName;
  size?: IconSize;
  /** optional color prop. by default will inherit color of the parent */
  color?: ColorsType;
  style?: React.CSSProperties;
}

export const Icon: React.FC<IconProps> = ({
  className,
  name,
  size,
  color,
  label,
  style,
  ...rest
}) => {
  const IconElement = icons[name];

  return (
    <IconElement
      className={classNames('vds-icon', size && `vds-icon--${size}`, className)}
      fill={color ? `var(${color})` : 'currentColor'}
      aria-label={label}
      aria-hidden={!label}
      name={`${name}-icon`}
      style={style}
      {...rest}
    />
  );
};
